// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const DictionaryEnumTypeDto = {
    CompanyProfile: 'COMPANY_PROFILE',
    CompanyStatus: 'COMPANY_STATUS',
    ProjectStatus: 'PROJECT_STATUS',
    UserRole: 'USER_ROLE',
    UserStatus: 'USER_STATUS',
    VacancyAttendance: 'VACANCY_ATTENDANCE',
    VacancyCandidateStatus: 'VACANCY_CANDIDATE_STATUS',
    VacancyClosureReason: 'VACANCY_CLOSURE_REASON',
    VacancyRequest: 'VACANCY_REQUEST',
    VacancyStatus: 'VACANCY_STATUS',
    VacancyVisibility: 'VACANCY_VISIBILITY',
} as const;

export type DictionaryEnumTypeDto = typeof DictionaryEnumTypeDto[keyof typeof DictionaryEnumTypeDto];



